<template>
    <AppHeader fixed class="animated slideInDown">
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.png" width="50" height="41" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/logo.png" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <b-navbar-nav class="ml-auto">
          <DefaultHeaderDropdownAccntCustomer />
      </b-navbar-nav>
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import DefaultHeaderDropdownAccntCustomer from './DefaultHeaderDropdownAccntCustomer'
import { mapState } from "vuex";
export default {
  name: 'DefaultHeader',
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccntCustomer,
    SidebarToggler
  },
  computed:{
     ...mapState("login", ["access_token"]),
  }
}
</script>

<style scoped>

  /*.app-header .navbar-toggler {*/
  /*  min-width: 50px;*/
  /*  padding: 0.25rem 0;*/
  /*  visibility: hidden !important;*/
  /*}*/


  @media(max-width:768px) {
    .app-header .navbar-brand {
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 20% !important;*/
      margin-left: -100px !important;
    }
  }

</style>
